// extracted by mini-css-extract-plugin
export default {"news":"News_news__orMUr","news__errorMessage":"News_news__errorMessage__zIQaa"};